export const formats = {
  DATE: 'DD.MM.YYYY',
}
